import { useTranslation } from 'react-i18next';
import { LegalHeading, LegalSubheading } from './styles';

export const GERMAN_TERMS_CONTENT = () => {
  const { t } = useTranslation();
  return (
    <>
      <LegalHeading id={t('terms-and-conditions-page-scroll-to-1')}>
        A) Allgemeine Geschäftsbedingungen & Teilnahmebedingungen für Teilnehmer
      </LegalHeading>

      <LegalSubheading>§ 1 Geltungsbereich</LegalSubheading>
      <div>
        (1) Die nachstehenden Teilnahmebedingungen gelten für alle
        Rechtsgeschäfte von we.CONECT Global Leaders GmbH, Sonnenallee 221,
        12059 Berlin, Deutschland („wir“) mit unserem Vertragspartner (“Sie”),
        der an unseren Veranstaltungen teilnimmt und unsere Produkte in Anspruch
        nimmt.
      </div>
      <div>
        (2) Im Rahmen dieser AGB gelten folgende Begrifflichkeiten:
        <br />
        Teilnahmeberechtigung
        <br /> ist die Berechtigung, an unserer Veranstaltung teilnehmen zu
        können
        <br />
        Käufer
        <br /> ist die Person, die nicht für sich, sondern für den Teilnehmer
        die Teilnahmeberechtigung beschafft.
      </div>

      <LegalSubheading>§ 2 Zustandekommen des Vertrages</LegalSubheading>
      <div>
        (1) Unsere Angebote sind grundsätzlich unverbindlich und freibleibend.
      </div>
      <div>
        (2) Durch die Übermittlung Ihrer Teilnahmeerklärung auf dem Postweg, per
        Fax, per E-Mail, über unser Booking-System auf unserer Webseite oder
        durch mündliche Absprache geben Sie ein verbindliches Angebot für den
        Vertragsschluss ab.
      </div>
      <div>
        (3) Ein Vertrag mit der we.CONECT Global Leaders GmbH kommt zustande,
        wenn wir Ihr Angebot annehmen.
      </div>
      <div>
        (4) Der Käufer der Teilnahmeberechtigung, der nicht selbst Teilnehmer
        ist (der also nicht die Teilnahmeberechtigung ausschließlich für sich
        selbst erwirbt oder bestellt), steht dafür ein, dass der Teilnehmer, der
        von ihm die Teilnahmeberechtigung erhält, Kenntnis von diesen AGB erhält
        und sie akzeptiert. Teilnehmer kann nur die Person sein, die namentlich
        auf der Teilnahmeberechtigung genannt ist.
      </div>

      <LegalSubheading>§ 3 Vertragsgegenstand</LegalSubheading>
      <div>
        (1) Wir können einzelne Bestandteile einer Veranstaltung ändern, wenn
        dies erforderlich ist und damit nicht wesentliche Teile der
        Veranstaltung verändert werden. Es besteht dann kein Anspruch auf
        Minderung oder Erstattung des Eintrittspreises, wenn die Änderung nicht
        wesentlich und nach den Umständen des Einzelfalls zumutbar ist.
      </div>
      <div>
        (2) Wir schulden, soweit Vorträge, Workshops, Ausstellungen,
        Abendveranstaltungen usw. der Vertragsgegenstand sind, eine
        ordnungsgemäße Auswahl von Referenten und Sprechern oder Ausstellern,
        sind aber nicht verantwortlich für deren Inhalte, für deren Art der
        Vermittlung und deren Behauptungen.
      </div>
      <div>
        (3) Wir können einzelne Referenten und Sprecher durch andere
        vergleichbare Referenten und Sprecher ersetzen, soweit dies dem
        Teilnehmer zumutbar ist und der Zweck der Veranstaltung sowie ihre
        Inhalte nicht wesentlich verändert werden.
      </div>
      <div>
        (4) Wir sind berechtigt, Ihnen über die von Ihnen angegebenen
        Kommunikationsmittel Informationen zur Veranstaltung zukommen zu lassen.
      </div>
      <div>
        (5) Wir sind auch berechtigt, dass wir vor Ort Foto- und Videoaufnahmen
        herstellen. Die Details werden Ihnen vor Ort über unsere
        Datenschutzinformationen mitgeteilt, Sie können diese auch vorab
        anfordern.
      </div>
      <div>(6) Das Hausrecht obliegt uns.</div>

      <LegalSubheading>§ 4 Teilnehmergebühren</LegalSubheading>
      <div>
        (1) Soweit eine Teilnahmegebühr für die jeweilige Veranstaltung erhoben
        wird, ergibt sie sich aus unseren Preisangaben oder Angeboten auf der
        jeweiligen Event-Webseite. Die Nutzung der digitalen Eventplattform ist
        nur in Kombination mit dem Kauf eines Bezahltickets oder der vollen
        Inanspruchnahme (inkl. Erscheinen auf dem Event) eines kostenlosen VIP /
        Freetickets Onsite-Tickets möglich.
      </div>
      <div>
        (2) Alle Abrechnungen erfolgen in Euro. Bei Zahlung mit ausländischen
        Währungen bzw. Zahlungsmitteln gehen Kursdifferenzen und Bankspesen zu
        Ihren Lasten.
      </div>
      <div>
        (3) Die Preise verstehen sich exklusive der gesetzlich geschuldeten
        Mehrwertsteuer.
      </div>
      <div>
        (4) Werden einzelne Leistungen durch Sie ohne unser Verschulden nicht in
        Anspruch genommen, so werden die vereinbarten Teilnahmegebühren sowie
        etwa zusätzliche weitere vereinbarte Gebühren und Kosten (z.B.
        Tagungspauschalen) dennoch fällig, soweit keine andere Vereinbarung
        getroffen wird.
      </div>

      <LegalSubheading>
        § 5 Zahlungsziel, Teilnahmeberechtigungen, Rücknahme/Umtausch
      </LegalSubheading>
      <div>
        (1) Der Teilnehmer hat we.CONECT den vereinbarten Pauschal- /
        Ticketpreis zuzüglich der gesetzlichen Mehrwertsteuer zu zahlen. Der
        Pauschal- / Ticketpreis zuzüglich der gesetzlichen Mehrwertsteuer ist 14
        Tage nach Rechnungsstellung fällig.
      </div>
      <div>
        (2) Ab 14 Tage vor Event der Pauschal- / Ticketpreis zuzüglich der
        gesetzlichen Mehrwertsteuer unmittelbar (am selben Tag) nach Erhalt der
        Rechnung fällig.
      </div>
      <div>
        (3) Die Tickets sind personalisiert. Teilnahmeberechtigt ist nur
        diejenige Person, deren Namen auf/in dem Ticket wiedergegeben ist.
      </div>
      <div>
        (4) Eine Rücknahme oder ein Umtausch oder eine Übertragung der
        Teilnahmeberechtigungen auf einen anderen Event ist generell nicht
        möglich.
      </div>

      <LegalSubheading>§ 6 Allgemeine Teilnahmebedingungen</LegalSubheading>
      <div>
        (1) Allgemeine Verbote:
        <br />
        den Veranstaltungsablauf zu stören
        <br />
        in Gebäuden außerhalb der gekennzeichneten Raucherbereiche zu rauchen,
        <br />
        strafbare, ordnungswidrige oder allgemein zu missbilligende Handlungen
        vorzunehmen oder dabei behilflich zu sein oder dazu anstiften,
        <br />
        Anlagen und Einrichtungen zu beschmieren, zu beschädigen oder zu
        entfernen,
        <br />
        Werbematerialien ohne unsere ausdrückliche schriftliche Zustimmung zu
        verteilen,
        <br />
        Tiere mitzubringen (ausgenommen Blindenhunde),
        <br />
        Waffen, gefährliche Gegenstände oder Drogen mitzuführen,
        <br />
        Ton-, Film- und Fotoaufnahmen ohne unsere ausdrückliche schriftliche
        Zustimmung zu machen.
        <br />
        Bei Verstoß können wir Sie der Veranstaltung verweisen. In diesem Fall
        haben Sie keinen Anspruch auf Erstattung der Teilnahmegebühren und
        sonstigen Kosten (z.B. Tagungspauschalen). Unser Recht, Schadenersatz
        geltend zu machen, bleibt unberührt.
      </div>
      <div>
        (2) Anreise, Einreisebestimmungen:
        <br />
        Sie sind selbst für die rechtzeitige Anreise, für die Rückreise und für
        die Einhaltung etwaiger Einreisebestimmungen und deren rechtzeitiger
        Vorbereitung (z.B. Beschaffung ggf. notwendiger Unterlagen)
        verantwortlich.
      </div>
      <div>
        (3) Hygiene Regeln:
        <br /> Sofern offiziell notwendig, gelten die zum Zeitpunkt der
        Veranstaltung bestehenden offiziellen Hygieneregeln und behördlichen
        Auflagen am Veranstaltungsort.
        <br /> Es gilt als Bedingung der Einlassberechtigung, dass der
        Teilnehmer diese Hygieneregeln und Auflagen während des Aufenthalts in
        der Veranstaltungsstätte vollumfänglich einhalten bzw. erfüllen kann.
        <br /> Die Hygieneregeln und Auflagen finden Sie auf unserer Webseite
        bzw. senden wir Ihnen auf Nachfrage gerne zu.
      </div>

      <LegalSubheading>§ 7 Urheberrechte</LegalSubheading>
      <div>
        (1) Die Ihnen ausgehändigten Dateien (Präsentationen, Handouts, etc.)
        unterliegen dem Urheberrechtsgesetz auch dann, wenn sie im Einzelfall
        nicht die erforderliche Schöpfungshöhe erreicht haben sollten. Sie
        dürfen die Unterlagen und Daten nur für den Privatgebrauch und im Rahmen
        der Erlaubnisse des Urheberrechtsgesetzes verwerten.
      </div>
      <div>
        (2) Foto-, Video- und Tonaufnahmen während der Veranstaltung sind Sie in
        angemessenem Umfang gestattet.
      </div>

      <LegalSubheading>§ 8 Höhere Gewalt</LegalSubheading>
      <div>
        (1) Im Falle, dass höhere Gewalt, zu einem Abbruch oder einer
        Unterbrechung des Vertrages oder der Veranstaltung oder einzelner
        vertragsgemäßer Leistungen führt, können wir von Ihnen die bis dahin
        angefallenen Kosten und erbrachten Leistungen anteilig verlangen, soweit
        es sich bei Ihnen um einen Unternehmer im Sinne des § 14 BGB handelt,
        höchstens aber 5 % der Teilnahmegebühren. Dies gilt auch, wenn einer
        unserer Leistungsträger bzw. Dienstleister (z.B. die
        Veranstaltungsstätte) aufgrund höherer Gewalt seine Leistungen uns
        gegenüber nicht erbringen kann. Schadenersatzansprüche gegen uns
        bestehen nicht.
      </div>
      <div>
        (2) Behördliche, polizeiliche oder gerichtliche Einstellungs- oder
        Abbruchverfügungen entsprechen der Höheren Gewalt aus Absatz 1, soweit
        nicht wir diese Verfügung schuldhaft verursacht haben.
      </div>
      <div>
        (3) Es gilt als vereinbart, dass als Höhere Gewalt im Sinne des Absatz 1
        auch die Empfehlung von staatlicher Seite (Bund, Land, Ministerien,
        Behörden) gilt, die Veranstaltung nicht durchzuführen (z.B. aufgrund
        einer pandemieartigen Ausbreitung eines Virus oder einer Terrorwarnung).
      </div>
      <div>
        (4) Es wird widerleglich vermutet, dass wir uns auf Höhere Gewalt im
        Sinne von Absatz 1 berufen können, wenn vergleichbare Veranstaltungen in
        gleich oder angrenzenden Bundesländern, in auch die Veranstaltung
        stattfindet, zum gleichen Zeitpunkt abgesagt bzw. nicht stattfinden.
        Ebenso wird widerleglich vermutet, dass wir uns nicht auf Höhere Gewalt
        berufen können, wenn vergleichbare Veranstaltungen in gleich oder
        angrenzenden Bundesländern, in den auch die Veranstaltung stattfindet,
        zum gleichen Zeitpunkt stattfinden.
      </div>
      <div>
        (5) Soweit eine nicht unerhebliche Anzahl von Teilnehmern unter Berufung
        auf ein außergewöhnliches Ereignis die Teilnahme bzw. Anwesenheit an der
        Veranstaltung absagen, und dadurch der prägende Charakter der
        Veranstaltung verloren geht, ist der Veranstalter berechtigt, die
        Veranstaltung mit der Rechtsfolge des Absatz 1 abzusagen. Erfolgt die
        Absage ausschließlich aufgrund einer nicht unerheblichen Absage von
        anderen Leistungsträgern, so können wir uns gemäß Absatz 1 auf Höhere
        Gewalt berufen, haben aber in diesem Fall keinen anteiligen Anspruch
        gegen den Teilnehmer.
      </div>
      <div>
        (6) Es gilt als vereinbart, dass Höhere Gewalt auch gegeben ist, wenn
        uns die Durchführung der Veranstaltung aufgrund anderer Auflagen der
        Behörden, soweit wir diese nicht zu vertreten haben, wirtschaftlich
        unzumutbar ist. In diesem Fall können wir uns gemäß Absatz 1 auf Höhere
        Gewalt berufen, haben aber keinen anteiligen Anspruch gegen den
        Teilnehmer.
      </div>
      <div>
        (7) Wird einem Teilnehmer der Eintritt oder die weitere Teilnahme auf
        der Veranstaltung verweigert, und beruht diese Verweigerung auf einer
        behördlichen Auflage, dass Personen mit Krankheitssymptomen nicht
        teilnehmen dürfen, so gilt dieser Umstand als Höhere Gewalt im Sinne des
        Absatz 1. Behaupten Sie vor Ort oder ohne Erscheinen das Vorliegen von
        Krankheitssymptomen, können wir die Vorlage eines ärztlichen Attests
        verlangen, das den hervorbringt, dass eine Teilnahme aufgrund
        behördlicher Auflage nicht möglich wäre.
      </div>
      <div>
        (8) Als milderes Mittel vor einer Absage der gesamten Veranstaltung als
        Live-Veranstaltung aufgrund Höherer Gewalt sind wir berechtigt, aber
        nicht verpflichtet, die Veranstaltung ganz oder teilweise digital
        durchzuführen. Soweit dadurch wesentliche Inhalte nicht wie vertraglich
        geschuldet geliefert werden, sind die Teilnahmegebühren entsprechend
        anzupassen. Außerdem entstehen durch eine Höhere Gewalt-bedingte
        Verlegung in den digitalen Bereich keine Schadenersatzansprüche des
        Teilnehmers gegen uns.
      </div>
      <div>
        (9) Wird die Veranstaltung von vornherein als sog. hybride Veranstaltung
        (d.h. dass die Veranstaltung digital durchgeführt wird, aber auch eine
        Präsenz des Teilnehmers vor Ort möglich ist) angekündigt, und muss die
        Veranstaltung aufgrund Höherer Gewalt ausschließlich digital
        durchgeführt werden, so hat der Teilnehmer keine Erstattungs- oder
        Schadenersatzansprüche gegen uns.
      </div>
      <div>
        (10) Wir können die Veranstaltung auch aus Gründen der Pietät absagen
        bzw. Ihnen einen alternativen Termin anbieten. Pietätsgründe sind
        gegeben, wenn zumindest auch in der Region des Veranstaltungsortes
        Trauerbeflaggung angeordnet ist oder vorgenommen wird oder sie
        bevorsteht, oder wenn ein schwerer Unfall bzw. Unglück innerhalb 24
        Stunden vor Veranstaltungsbeginn geschieht, über das in der Region des
        Veranstaltungsortes in der überwiegenden Anzahl der Medien berichtet
        wird, oder wenn der Vorfall vor mehr als 24 Stunden geschehen ist, aber
        die Berichterstattung in der überwiegenden Anzahl der Medien durch
        Sondersendungen noch präsent ist, oder wenn vergleichbare
        Veranstaltungen aufgrund desselben Vorfalls abgesagt werden. In diesem
        Fall erstatten wir etwa bereits bezahlte Teilnahmegebühren ohne etwa
        angefallene Vorverkaufsgebühren zurück, Schadenersatzansprüche sind
        ausgeschlossen.
      </div>

      <LegalSubheading>§ 9 Stornierung durch Sie</LegalSubheading>
      <div>
        (1) Soweit Sie den Vertrag aus einem Grund aufheben möchten, den wir
        nicht zu vertreten haben und der nicht auf Höherer Gewalt beruht
        (“Stornierung“), so ist dies mit Rücksprache mit uns grundsätzlich
        möglich; wir dürfen die Aufhebung nicht wider Treu und Glauben
        verweigern. In dem Fall einer einvernehmlichen Aufhebung des Vertrages
        können wir, nicht angesichts der Tatsache, dass wir erfahrungsgemäß bei
        einer Absage keine Möglichkeit mehr haben, die freien Plätze anderweitig
        zu vergeben und wir ggf. selbst unsere Beauftragten oder Referenten
        nicht mehr kostenfrei stornieren können, Kosten und Gebühren usw. nach
        folgender Maßgabe geltend machen, soweit mit Ihnen nichts anderes
        vereinbart:
      </div>
      <div>
        (2) Wir werden wahlweise die konkret vereinbarten Kosten abzüglich
        ersparter Aufwendungen geltend machen oder unsere Kosten und unseren
        entgangenen Gewinn mit einer Pauschale abrechnen. In diesem Fall gelten
        dann folgende Pauschalen: Bis zu 5 Werktage ab dem Buchungsdatum: 80%
        der Teilnahmegebühr; danach oder bei Nichtbesuch 100% der
        Teilnahmegebühr.
      </div>

      <LegalSubheading>§ 10 Datenschutz</LegalSubheading>
      <div>
        Wir verweisen auf unsere Datenschutzinformationen, die Sie im
        Zusammenhang mit der Anmeldung einsehen und auch jederzeit bei uns
        anfordern können.
      </div>

      <LegalSubheading>§ 11 Unsere Haftung</LegalSubheading>
      <div>
        (1) Pflichtverletzungen, die zu Sach- oder Vermögensschäden führen: Bei
        nur leicht fahrlässigen Pflichtverletzungen beschränkt sich unsere
        Haftung auf den nach der Art des Vertrages vorhersehbaren,
        vertragstypischen Durchschnittsschaden.
        <br />
        Wir haften bei nur leicht fahrlässiger Verletzung unwesentlicher
        Vertragspflichten nicht. “Unwesentlich“ sind solche Pflichten, deren
        Erfüllung den Vertrag nicht prägen und auf die Sie nicht vertrauen
        dürfen. Mittelbare Schäden und Folgeschäden, die Folge von Mängeln des
        Vertragsgegenstandes sind, sind nur ersatzfähig, soweit solche Schäden
        bei bestimmungsgemäßer Verwendung des Vertragsgegenstandes
        typischerweise zu erwarten sind.
        <br />
        Die Haftungsbeschränkungen dieses Absatzes 1 gelten nicht bei grob
        fahrlässiger oder vorsätzlicher Pflichtverletzung.
      </div>
      <div>
        (2) Pflichtverletzungen, die zur Verletzung von Leben, Körper oder
        Gesundheit führen:
        <br /> Wir haften für jede Art von Fahrlässigkeit und Vorsatz bei der
        uns zurechenbaren Verletzung von Leben, Körper oder Gesundheit von
        Ihnen.
      </div>
      <div>
        (3) Gesetzlich zwingende Haftung:
        <br />
        Die Haftungsbeschränkungen in Absatz 1 betreffen nicht Ihre Ansprüche
        aus Produkthaftung und aus gesetzlich zwingenden Haftungstatbeständen.
      </div>
      <div>
        (4) Erstreckung dieser Klausel auf Beschäftigte, Organe,
        Erfüllungsgehilfen u.a.: Die Haftungsbeschränkungen in Absatz 1 gelten
        im gleichen Umfang zu Gunsten unserer Organe, unserer Beschäftigten und
        sonstigen Erfüllungsgehilfen und unseren Subunternehmern.
      </div>

      <LegalSubheading>§ 12 Gerichtsstand und Rechtswahl</LegalSubheading>
      <div>
        (1) Gerichtsstand:
        <br />
        Als Gerichtsstand wird unser Geschäftssitz vereinbart, wenn Sie Kaufmann
        sind oder keinen allgemeinen Gerichtsstand in der Bundesrepublik
        Deutschland haben. Wir sind dann aber auch berechtigt, in diesem Fall an
        Ihrem Geschäftssitz zu klagen.
      </div>
      <div>
        (2) Rechtswahl:
        <br />
        wenn Sie Unternehmer (§ 14 BGB) sind, gilt: Es gilt deutsches Recht.
        <br />
        Wenn Sie Verbraucher (§ 13 BGB) sind, gilt: Für diese AGB und die
        Vertragsbeziehung mit Ihnen gilt das Recht der Bundesrepublik
        Deutschland unter Ausschluss materiellen EU-Rechts. Die gesetzlichen
        Vorschriften zur Beschränkung der Rechtswahl bleiben jedoch unberührt.
        Insbesondere gilt aufgrund von Artikel 6 Absatz 2 der VO (EG) Nr.
        593/2008, (so genannte “Rom-I-Verordnung“) in deren räumlichem
        Anwendungsbereich: Soweit das Recht des Staates, in dem Sie zum
        Zeitpunkt des Vertragsschlusses Ihren gewöhnlichen Aufenthalt haben
        (nachstehend “Wohnsitzrecht“), Bestimmungen zu Ihrem Schutz enthält, von
        denen nach dem Wohnsitzrecht nicht durch Vereinbarung abgewichen werden
        darf, gelten für Sie die (günstigeren) Bestimmungen Ihres
        Wohnsitzrechts. Sie genießen also trotz der Rechtswahl gemäß Satz 1
        stets den Schutz der zwingenden Bestimmungen Ihres Wohnsitzrechts.
      </div>

      <LegalHeading id={t('terms-and-conditions-page-scroll-to-2')}>
        B) Allgemeine Geschäftsbedingungen & Teilnahmebedingungen für
        Sponsoren/Business-Partner
      </LegalHeading>

      <LegalSubheading>§ 1 Geltungsbereich</LegalSubheading>
      <div>
        (1) Die nachstehenden Teilnahmebedingungen gelten für alle
        Rechtsgeschäfte von we.CONECT Global Leaders GmbH, Sonnenallee 221,
        12059 Berlin, Deutschland („wir“) mit unserem Vertragspartner (“Sie”),
        der an unseren Veranstaltungen teilnimmt und unsere Produkte in Anspruch
        nimmt.
      </div>
      <div>
        (2) Im Rahmen dieser AGB gelten folgende Begrifflichkeiten:
        <br />
        Teilnahmeberechtigung
        <br /> ist die Berechtigung, an unserer Veranstaltung teilnehmen und als
        Aussteller, Sponsor, Business Partner auftreten zu können.
        <br />
        Käufer
        <br /> ist die Person, die nicht für sich, sondern für den Aussteller,
        Sponsor, Business Partner die Teilnahmeberechtigung beschafft.
      </div>

      <LegalSubheading>§ 2 Zustandekommen des Vertrages</LegalSubheading>
      <div>
        (1) Unsere Angebote sind grundsätzlich unverbindlich und freibleibend.
      </div>
      <div>
        (2) Durch die Übermittlung Ihrer Teilnahmeerklärung auf dem Postweg, per
        Fax, per E-Mail, über unser Booking-System auf unserer Webseite oder
        durch mündliche Absprache geben Sie ein verbindliches Angebot für den
        Vertragsschluss ab.
      </div>
      <div>
        (3) Ein Vertrag mit der we.CONECT Global Leaders GmbH kommt zustande,
        wenn wir Ihr Angebot annehmen.
      </div>
      <div>
        (4) Der Käufer der Teilnahmeberechtigung, der nicht selbst Aussteller,
        Sponsor, Business Partner ist (der also nicht die Teilnahmeberechtigung
        ausschließlich für sich selbst erwirbt oder bestellt), steht dafür ein,
        dass der Aussteller, Sponsor, Business Partner, der von ihm die
        Teilnahmeberechtigung erhält, Kenntnis von diesen AGB erhält und sie
        akzeptiert.
      </div>

      <LegalSubheading>
        § 3 Aussteller-, Sponsor-, Business Partner-, Teilnehmergebühren
      </LegalSubheading>
      <div>
        (1) Die Aussteller-, Sponsor-, Business Partner-, Teilnehmergebühr
        ergibt sie sich aus unseren Preisangaben oder Angeboten auf der
        jeweiligen Event-Webseite und / oder aus dem Angebot unseres Vertriebs.
      </div>
      <div>
        (2) Alle Abrechnungen erfolgen in Euro. Bei Zahlung mit ausländischen
        Währungen bzw. Zahlungsmitteln gehen Kursdifferenzen und Bankspesen zu
        Ihren Lasten.
      </div>
      <div>
        (3) Die Preise verstehen sich exklusive der gesetzlich geschuldeten
        Mehrwertsteuer.
      </div>

      <LegalSubheading>
        § 4 Zahlungsziel, Teilnahmeberechtigungen
      </LegalSubheading>
      <div>
        (1) Der Aussteller, Sponsor, Business Partner, Teilnehmer hat we.CONECT
        den vereinbarten Pauschal- , Ticket-, Packagepreis zuzüglich der
        gesetzlichen Mehrwertsteuer zu zahlen. Der Pauschal- , Ticket-,
        Packagepreis zuzüglich der gesetzlichen Mehrwertsteuer ist 14 Tage nach
        Rechnungsstellung fällig.
      </div>
      <div>
        (2) Ab 14 Tage vor Event der Pauschal- , Ticket-, Packagepreis zuzüglich
        der gesetzlichen Mehrwertsteuer unmittelbar (am selben Tag) nach Erhalt
        der Rechnung fällig.
      </div>

      <LegalSubheading>
        § 5 Leistungen und Pflichten des Veranstalters
      </LegalSubheading>
      <div>
        (1) Der Veranstalter räumt dem Partner die individuell vereinbarten
        Werbemaßnahmen ein. Darin inbegriffen sind alle Maßnahmen der
        Unternehmenskommunikation und Leistungen, die dem Partner in
        Zusammenhang mit der Veranstaltung gestattet und erbracht werden.
      </div>
      <div>
        (2) Der Veranstalter kann mit anderen Partnern/Sponsoren auch aus
        derselben Branche Sponsorverträge schließen oder deren Leistungen für
        die Veranstaltung in Anspruch nehmen bzw. beauftragen.
      </div>
      <div>
        (3) Der Veranstalter überlässt dem Partner zeitnah nach der
        Veranstaltung eine Kurzinformation über die erbrachten Leistungen.
      </div>
      <div>
        (4) Der Veranstalter kann Änderungen am Inhalt, Ort, Zeit und Ablauf der
        Veranstaltung vornehmen, soweit diese unwesentlich und für die
        Erreichung des Vertragszweckes für den Partner zumutbar sind.
      </div>

      <LegalSubheading>
        § 6 Leistungen und Pflichten des Partners
      </LegalSubheading>
      <div>
        (1) Der Partner beachtet die in diesem Vertrag geregelten Bestimmungen.
      </div>
      <div>
        (2) Hat der Partner das Recht, einen Stand aufzustellen oder zu
        betreiben, gelten die Allgemeinen Bedingungen des Veranstalters für
        Aussteller entsprechend.
      </div>
      <div>
        (3) Der Partner hat entsprechendes Brandingmaterial für den Event bis
        spätestens 14 Tage vor dem Eventdatum einzureichen.
      </div>
      <div>
        (4) Sofern im Package-, Ticket-, Vertrag enthalten sind vereinbarte
        One2Ones eigenständig über die zur Verfügung gestellte Event App
        einzustellen.
      </div>

      <LegalSubheading>
        § 7 Nutzung von Marken, Kennzeichen, Urheberrechten usw.
      </LegalSubheading>
      <div>
        (1) Beide Vertragspartner sichern zu, dass der jeweils andere
        Vertragspartner Namen, Werke, Titel, Kennzeichen und Marken (im Weiteren
        nur noch: Kennzeichen) öffentlich zum Zwecke der Vertragsdurchführung
        nutzen darf und dazu jeweils ein einfaches Nutzungsrecht erhält. Beide
        Vertragspartner stellen sich gegenseitig zur Durchführung der
        Veranstaltung und Umsetzung der Leistungen und Zuständigkeiten die für
        diesen Zweck notwendigen Rechte an den Kennzeichen kostenfrei zur
        Verfügung und stehen dafür ein, dass diese Rechte frei von Rechten
        Dritter sind. Durch die vertragsgemäße Nutzung eines Kennzeichens
        erwirbt der nutzende Vertragspartner keine über diesen Vertrag
        weitergehenden Rechte daran. <br /> Beide Vertragspartner verpflichten
        sich auch, die bestehenden Kennzeichen nicht in anderen Ländern
        eintragen oder eintragen zu lassen oder sonst zu verwenden oder
        verwenden zu lassen, um dort Rechte zu generieren.
      </div>
      <div>
        (2) Soweit die Vertragspartner künftig gemeinsame Rechte an einem
        Kennzeichen erwerben, gilt der vorstehende Absatz 1 entsprechend mit der
        Maßgabe, dass beide Vertragspartner gleichberechtigt Rechtsinhaber
        werden. <br />
        Beide Vertragspartner verpflichten sich auch, nach Vertragsabschluss,
        die bestehenden Kennzeichen nicht in Deutschland und nicht in anderen
        Ländern einzutragen oder eintragen zu lassen oder sonst zu verwenden
        oder verwenden zu lassen, um dort Rechte zu generieren. Die Eintragung
        kann gemeinsam bzw. mittels separater Vereinbarung erfolgen.
      </div>
      <div>
        (3) Soweit ein Vertragspartner oder Rechteinhaber an ihrem Kennzeichen
        aus rechtlicher Sicht oder aus Sicht der Unternehmens-C.I. bestimmte
        Anforderungen stellen, so ist dies dem anderen Vertragspartner in
        Vorfeld mitzuteilen.
      </div>
      <div>
        (4) Die Verpfändung oder Lizenzrechte in diesem Vertrag ist
        ausgeschlossen.
      </div>
      <div>
        (5) Vom Vertragspartner erstellte Unterlagen, Graphiken, Aufstellungen,
        Zeichnungen und Skizzen und andere Gegenstände verbleiben in seinem
        Eigentum, soweit der Eigentumsübergang nicht Vertragsgegenstand ist.
      </div>
      <div>
        (6) Freistellungsverpflichtung: Der Partner ist verpflichtet, den
        Veranstalter von jeglicher Inanspruchnahme durch Dritte und Kosten
        freizustellen, die durch eine Inanspruchnahme durch Dritte entstehen,
        soweit die Inanspruchnahme auf einem Verstoß des Partners gegen eine der
        hier vereinbarten Regelungen, Vereinbarungen aus einem Einzelauftrag,
        aus einer späteren Vereinbarung, oder wenn eine gesetzliche oder
        sonstige Vorschrift oder einem sonst rechtswidrigen Verhalten beruht.
        Diese Freistellungsverpflichtung gilt im Rahmen der gesetzlichen
        Verjährung auch nach Vertragsende fort, wenn die Inanspruchnahme erst
        nach Vertragsende erfolgt. Dies gilt auch, wenn der Vertrag vorzeitig
        durch Höhere Gewalt oder andere Ereignisse beendet wird.
      </div>
      <div>
        (7) Dies gilt für Werbemaßnahmen jeder Art, die gemäß § 1 vereinbart
        sind, ebenso wie für die Präsenz des Partners auf der Live-Veranstaltung
        (gleich ob körperlich oder digital), ebenso für jegliche digitale
        Umsetzung der Veranstaltung.
      </div>

      <LegalSubheading>
        § 8 Wenn vereinbart: Standplatz, Präsentation, Sichtbarkeit
      </LegalSubheading>
      <div>
        (1) Der Veranstalter kann Flächen in eigenem Ermessen dem Aussteller
        zuordnen, ein Anspruch auf eine bestimmte Fläche besteht nur, wenn dies
        ausdrücklich so schriftlich vereinbart ist.
      </div>
      <div>
        (2) Die Überlassung eines Standplatzes erfolgt unter der Bedingung, dass
        der Ausstellungsstand, seine Inhalte, dort präsentierte Waren, die Art
        der Präsentation und das Personal Dritte nicht belästigen, insbesondere
        auch andere Aussteller nicht stören und dem Veranstaltungszweck
        entgegenstehen.
      </div>
      <div>
        (3) Der Veranstalter kann die zugewiesene Standfläche, soweit nicht fix
        vereinbart, verlegen, soweit die Verlegung für den Partner zumutbar ist
        und den Vertragszweck nicht beeinträchtigt.
      </div>
      <div>
        (4) Die Überlassung der Ihnen zugewiesenen Fläche an Dritte durch den
        Partner selbst ist nur nach vorheriger, ausdrücklicher, schriftlicher
        Zustimmung durch den Veranstalter erlaubt. Der Partner ist dafür
        verantwortlich, dass für Dritte diese Bedingungen anerkannt und
        einbehalten. Eine Zustimmung durch den Veranstalter entlässt den Partner
        nur dann aus den hier genannten Rechten und Pflichten, wenn beide
        Parteien dies ausdrücklich schriftlich vereinbart haben.
      </div>
      <div>
        (5) Die überlassenen Bereiche sind während der Veranstaltung sauber und
        aufgeräumt zu halten. Der Stand ist in der Veranstaltungszeit mit
        kundigem Personal besetzt zu halten. Für die Sicherheit des
        Standbetriebes ist ausschließlich der Partner verantwortlich.
      </div>
      <div>
        (6) Werbung außerhalb des Standes ist nur mit vorheriger ausdrücklicher,
        und schriftlicher Zustimmung des Veranstalters erlaubt.
      </div>
      <div>
        (7) Eine Bewachung des Standes ist nicht durch den Veranstalter
        geschuldet. Dem Partner wird empfohlen, für eine ausreichende Sicherung
        bzw. auch Versicherung zu sorgen.
      </div>
      <div>
        (8) Der Veranstalter ist berechtigt, im Falle eines dringlichen Betriebs
        der Veranstaltungsstätte, die der Veranstalter dem Partner auf Wunsch
        überlässt.
      </div>
      <div>
        (9) Hygiene Regeln:
        <br /> Sofern offiziell notwendig, gelten die zum Zeitpunkt der
        Veranstaltung bestehenden offiziellen Hygieneregeln und behördlichen
        Auflagen am Veranstaltungsort.
        <br /> Es gilt als Bedingung der Einlassberechtigung, dass der
        Teilnehmer diese Hygieneregeln und Auflagen während des Aufenthalts in
        der Veranstaltungsstätte vollumfänglich einhalten bzw. erfüllen kann.
        Die Hygieneregeln und Auflagen finden Sie auf unserer Webseite bzw.
        senden wir Ihnen auf Nachfrage gerne zu.
      </div>
      <div>
        (10) Hybride oder digitale Veranstaltungen:
        <br />
        Findet die Veranstaltung ganz oder teilweise digital statt und erhält
        der Partner die Möglichkeit, sich digital zu präsentieren, so steht der
        Partner dafür ein, dass für jegliche veranstaltungsbezogene Nutzung
        durch den Veranstalter die entsprechenden notwendigen Rechte dem
        Veranstalter eingeräumt werden. Dies gilt auch, soweit
        Persönlichkeitsrecht bzw. personenbezogene Daten von Beschäftigten oder
        Gehilfen des Partners betroffen sind.
      </div>

      <LegalSubheading>§ 9 Inhalte der Aktivitäten</LegalSubheading>
      <div>
        (1) Beide Vertragspartner stehen dafür ein, dass eigene
        Handlungen/Aussagen keine politischen, diskriminierenden, rassistischen,
        extremistischen oder sonst gegen die guten Sitten verstoßenden
        Äußerungen, Andeutungen oder Darstellungen enthalten; keine Äußerungen,
        Andeutungen oder Darstellungen enthalten, die mit demokratischen
        Grundwerten und/oder dem Grundgesetz der Bundesrepublik Deutschland
        unvereinbar sind und/oder sich auf das friedliche Zusammenleben der
        Menschen in Deutschland negativ auswirken; keine Äußerungen, Andeutungen
        oder Darstellungen enthalten, die das positive Image des jeweils anderen
        Vertragspartners beeinträchtigen.
      </div>
      <div>
        (2) Die Vertragspartner informieren sich unverzüglich, sobald sie mit
        Handlungen, Maßnahmen, Marketingaktivitäten usw. des anderen nicht
        einverstanden sein sollten oder Verstöße feststellen.
      </div>
      <div>
        (3) Die Vertragspartner legen jederzeit auf Wunsch ihre Planungen und
        Aktivitäten in Bezug auf die Vertragsdurchführung offen und unterstützen
        sich bei der Wahrung des positiven Images.
      </div>

      <LegalSubheading>§ 10 Informationsaustausch</LegalSubheading>
      <div>
        Im Falle eines Unfalls oder eines sicherheitsrelevanten Ereignisses, das
        Aufmerksamkeit der Presse erregt, sollen die Vertragspartner sich vor
        Äußerungen gegenüber der Presse abstimmen und Informationen austauschen.
      </div>

      <LegalSubheading>§ 11 Vertraulichkeit</LegalSubheading>
      <div>
        (1) Die Vertragspartner vereinbaren über Betriebs- und
        Geschäftsgeheimnisse gegenseitig absolutes Stillschweigen auch über das
        Vertragsende hinaus.
      </div>
      <div>
        (2) Als Betriebs- und Geschäftsgeheimnisse werden alle auf das
        Unternehmen bezogenen Tatsachen, Umstände und Vorgänge verstanden, die
        nicht offenkundig, sondern nur einem begrenzten Personenkreis zugänglich
        sind und an deren Nichtverbreitung der Rechtsinhaber ein berechtigtes
        Interesse hat. Betriebsgeheimnisse umfassen im Wesentlichen technische
        Kenntnisse, Verfahren, Pläne, Erfahrungen, Rezepte,
        Konstruktionszeichnungen, kaufmännisches Wissen.
      </div>
      <div>
        (3) Die Vertragspartner verpflichten sich, auch über die Höhe der
        vereinbarten Zahlungen und den Inhalt dieses Vertrages Stillschweigen
        gegenüber Dritten zu bewahren. Dies gilt auch nach Vertragsende fort.
      </div>

      <LegalSubheading>§ 12 Datenschutz</LegalSubheading>
      <div>
        (1) Beschäftigte oder Subunternehmer des Partners: Nutzung der Daten /
        Weitergabe unter Datenschutzinformation: Der Partner ist verpflichtet,
        seine Beschäftigten und Subunternehmer als Vertragspartner auf die
        datenschutzrechtlichen Informationspflichten, die auch an die von ihm zu
        benennenden verantwortlichen Personen und Ansprechpartner weitergegeben
        werden, hinzuweisen und diese über die im Zusammenhang mit dem Vertrag
        erfolgenden Datenverarbeitungsvorgänge und Datenschutzmaßnahmen
        umfassend, rechtzeitig und nachweisbar zu informieren.
      </div>
      <div>
        (2) Gemeinsame Verantwortlichkeit, weitere Vereinbarungen: Soweit
        notwendig, werden die Vertragspartner auch nach Vertragsabschluss
        entsprechende datenschutzrechtliche Vereinbarungen schließen, die auf
        der EU-Datenschutz-Grundverordnung (DSGVO) und dem
        Bundesdatenschutzgesetz (BDSG) beruhen (z.B. einen Vertrag über die
        gemeinsame Verantwortlichkeit gemäß Art. 26 DSGVO oder einen
        Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO).
      </div>

      <LegalSubheading>§ 13 Haftung</LegalSubheading>
      <div>
        (1) Der Veranstalter übernimmt keine Gewähr dafür, dass beim Partner ein
        Werbeerfolg eintritt. Insbesondere gewährleistet der Veranstalter nicht,
        dass tatsächlich ausreichend Besucher die Veranstaltung aufsuchen.
      </div>
      <div>
        (2) Beide Vertragspartner schließen jeweils ihre Haftung für leicht
        fahrlässig verursachte Sach- und Vermögensschäden, die er bei dem
        anderen Vertragspartner verursacht, aus. Nicht ausgeschlossen sind
        Ansprüche Dritter.
      </div>

      <LegalSubheading>
        § 14 Höhere Gewalt und (teilweise) Nichterfüllung der Veranstaltung
      </LegalSubheading>
      <div>
        (1) Im Falle Höherer Gewalt, die zu einem Ausfall, einem Abbruch oder
        einer Unterbrechung der unterstützten Veranstaltung führt, findet eine
        Rückabwicklung etwa bereits ausgetauschter Leistungen statt und
        verlieren beide Vertragspartner etwa noch bestehende oder bestehende
        Leistungsansprüche (Anspruch auf Zahlung, Anspruch auf Werbung bzw.
        Durchführung der Veranstaltung) gegen den anderen.
        Schadenersatzansprüche entstehen nicht. Dies gilt dann nicht, wenn die
        bereits erbrachte Leistung des einen Vertragspartners ohne eine
        ausgeglichene Leistung des anderen Vertragspartners zu einem
        unvermutbaren Nachteil des (bereits vor-) leistenden Vertragspartners
        oder zu einem wider Treu und Glauben bestehenden Vorteil beim anderen
        Vertragspartner führen würde (z.B. wenn der Veranstalter bereits
        Werbemaßnahmen zugunsten des Partners erbracht, der Partner aber noch
        keine Zahlungen geleistet hat; oder wenn der Partner bereits Zahlungen
        geleistet, der Veranstalter aber noch keinerlei Werbemaßnahmen
        eingeleitet hat). Insoweit gilt also als vereinbart, dass die in § 1
        genannten Leistungen teilbar sind. <br />
        Für alle Live &amp; Hybrid Event Formate gilt: Es wird für beide
        Parteien widerleglich vermutet, dass die 4 Leistungspakete vom
        Gesamtwert jeweils ausmachen: “Vor Event“ = 10 %, “Auf Live Event“ = 40
        %, “Auf digitalem Event“ = 30 % und “Nach dem Event“ = 20 %. Diese
        Paketwerte, soweit die Vermutung nicht widerlegt wird, sind der
        Bewertung der teilbaren Leistungen zugrunde zu legen. Für alle reinen
        Digital Event Formate gilt: Es wird Digital Event Formate gilt: Es wird
        für beide Parteien widerleglich vermutet, dass die 3 Leistungspakete vom
        Gesamtwert jeweils ausmachen: “Vor Event“ = 20 %, “Auf digitalem Event“
        = 50 % und “Nach dem Event“ = 30 %. Diese Paketwerte, soweit die
        Vermutung nicht widerlegt wird, sind der Bewertung der teilbaren
        tatsächlich erbrachten Leistungen zugrunde zu legen. zugrunde zu legen.
      </div>
      <div>
        (2) Behördliche, polizeiliche oder gerichtliche Einstellungs- oder
        Abbruchverfügungen entsprechen der Höheren Gewalt aus Absatz 1, soweit
        nicht ein Vertragspartner diese Verfügung schuldhaft verursacht hat.
      </div>
      <div>
        (3) Es gilt als vereinbart, dass als Höhere Gewalt im Sinne des Absatz 1
        auch die Empfehlung von staatlicher Seite (Bund, Land, Ministerien,
        Behörden) gilt, die Veranstaltung nicht durchzuführen (z.B. aufgrund
        einer pandemieartigen Ausbreitung eines Virus oder einer Terrorwarnung).
      </div>
      <div>
        (4) Es gilt als vereinbart, dass Höhere Gewalt auch gegeben ist, wenn
        dem Veranstalter die Durchführung der Veranstaltung aufgrund erhöhter
        Auflagen der Behörden, soweit er diese nicht zu vertreten hat,
        wirtschaftlich unzumutbar ist. In diesem Fall kann er sich gemäß Absatz
        1 auf Höhere Gewalt berufen.
      </div>
      <div>
        (5) Es wird widerleglich vermutet, dass sich der Veranstalter auf Höhere
        Gewalt im Sinne von Absatz 1 berufen kann, wenn vergleichbare
        Veranstaltungen im gleichen oder angrenzenden Bundesland, in dem auch
        die Veranstaltung stattfindet, zum gleichen Zeitpunkt abgesagt werden
        bzw. nicht stattfinden. Ebenso wird widerleglich vermutet, dass sich der
        Veranstalter nicht auf Höhere Gewalt berufen kann, wenn vergleichbare
        Veranstaltungen in gleichen oder angrenzenden Bundesland, in dem auch
        die Veranstaltung stattfindet, zum gleichen Zeitpunkt stattfinden.
      </div>
      <div>
        (6) Im Sinne des Gesundheitsschutzes der Beschäftigten beider Parteien,
        aber auch der Teilnehmer und Mitwirkenden, wird vereinbart, dass Höhere
        Gewalt nach Absatz 1 auch gilt, wenn eine Person solche
        Krankheitssymptome aufweist, die nach den Vorgaben des
        Robert-Koch-Instituts oder einer staatlichen Stelle zu einem zwingenden
        oder empfohlenen Ausschluss von der Veranstaltung führen und wenn diese
        Person nicht zumutbar durch eine andere Person ersetzt werden kann (z.B.
        Veranstaltungsleiter oder Projektleiter).
      </div>
      <div>
        (7) Soweit eine nicht unerhebliche Anzahl von Teilnehmern, Aussteller
        oder anderen Beteiligten unter Berufung auf ein außergewöhnliches
        Ereignis die Teilnahme bzw. Anwesenheit an der Veranstaltung absagen,
        und dadurch der prägende Charakter der Veranstaltung verloren geht, ist
        der Veranstalter berechtigt, die Veranstaltung mit der Rechtsfolge des
        Absatz 1 abzusagen.
      </div>
      <div>
        (8) Es gilt als vereinbart, dass als Höhere Gewalt im Sinne des Absatz 1
        auch der Absagegrund “Pietät“ gilt. Aus Pietätsgründen kann der
        Veranstalter die Veranstaltung absagen, wenn die Durchführung der
        Veranstaltung und/oder Fortsetzung der Werbung für die Veranstaltung
        und/oder einzelne Werbemaßnahmen in der Öffentlichkeit als pietätlos
        wahrgenommen würden; als Indiz für die Pietätlosigkeit gilt bspw., wenn
        in der Region, in der die Veranstaltung stattfindet, sich ein schwerer
        Unfall oder schwerer Vorfall ereignet hat, zu Sondersendungen in TV und
        Radio führt, oder Trauerbeflaggung in der Region aus dmselben Grund
        abgesagt werden. Indiz dafür ist auch die Erkenntnis, wenn beide
        Vertragspartner den Vertrag vor Kenntnis des Vorfalls nicht geschlossen
        oder sich in Kenntnis des Vorfalls nicht darauf vertraglich gebunden
        hätten.
      </div>
      <div>
        (9) Transformation von Live zu digital: Als milderes Mittel vor einer
        Absage der Veranstaltung aufgrund eines Ereignisses im Sinne des § 9
        kann der Veranstalter diese ganz oder teilweise digital durchführen, ist
        dazu aber nicht verpflichtet. Die gegenseitigen vertraglichen Leistungen
        im Falle einer Verlegung in den digitalen Bereich im Sinne von § 313 BGB
        angemessen anzupassen und dabei die in § 9 Absatz 1 genannten
        Prozent-Werte für die Bewertung der einzelnen Leistungen oder Pakete
        heranzuziehen. Soweit nicht wesentliche Leistungen des Veranstalters
        entfallen, wird bei einer Verlegung in den digitalen Bereich
        widerleglich vermutet, dass die einzelnen Pakete zu 20 %, die obere
        Grenze bei 80 % liegt. Der Partner das Recht, von einer Teilnahme an
        einer solchen digitalen Veranstaltung zurückzutreten, wenn die Teilnahme
        daran für ihn unzumutbar ist. Der Rücktritt muss unverzüglich nach
        unserer Bekanntgabe der Verlegung in den digitalen Bereich erklärt
        werden, andernfalls wird widerleglich vermutet, dass der Partner die
        Verlegung nicht oder nicht in der Kürze der Zeit digital dargestellt
        wissen wollte oder eine digitale Präsentation hinzunehmen ist und wird
        wechselseitiger Aussteller ebenfalls aus diesem Grund zurücktreten. Im
        Falle der Teilnahme an der digitalen Durchführung gelten diese
        Bestimmungen der Ausstellerbedingungen entsprechend.
      </div>

      <LegalSubheading>§ 15 Abwerbeverbot</LegalSubheading>
      <div>
        Der Vertragspartner wird es unterlassen, angestellten Mitarbeitern von
        der we.CONECT Global Leaders GmbH während der Dauer der Zusammenarbeit
        der Parteien und zweier Kalenderjahre danach ein Angebot zur Anstellung
        zu unterbreiten (Abwerbeverbot). Einem solchen Arbeitsvertrag stehen
        andere Angebote und Vereinbarungen gleich, aufgrund derer die
        Arbeitskraft des Mitarbeiters nicht mehr von der we.CONECT Global
        Leaders GmbH zugutekommt, sondern ganz oder teilweise dem
        Vertragspartner. Für jede Verletzung dieses Abwerbeverbotes gemäß diesem
        Artikel, verpflichtet sich der Vertragspartner, der we.CONECT Global
        Leaders GmbH unverzüglich eine Vertragsstrafe in Höhe von 100 %
        (einhundert Prozent) des jährlichen Brutto-Betrages, den der
        Vertragspartner dieser Person bezahlt, jedoch nicht weniger als EUR
        65.000,00 (Fünfundsechzigtausend Euro) zu bezahlen. Davon bleibt das
        Recht der we.CONECT Global Leaders unberührt, Schadenersatzansprüche
        geltend zu machen, welche über die Vertragsstrafe hinausgehen. Der
        Vertragspartner trägt die Beweislast.
      </div>

      <LegalSubheading>§ 16 Sonstiges</LegalSubheading>
      <div>
        (1) Abtretung: <br />
        Der Partner kann Ansprüche aus dem Vertragsverhältnis mit nur mit
        vorherigen ausdrücklichen Zustimmung des Veranstalters an Dritte
        abtreten.
      </div>
      <div>
        (2) Gerichtsstand: <br />
        Gerichtsstand für alle Ansprüche aus dem Vertragsverhältnis ist der
        Geschäftssitz des Veranstalters. Er ist auch berechtigt, den
        Gerichtsstand am Geschäftssitz des Partners zu wählen.
      </div>
      <div>
        (3) Rechtswahl: <br />
        Es gilt deutsches Recht.
      </div>
      <div>
        (4) Sprache: <br /> Sollten diese Allgemeinen Bedingungen neben der
        deutschen Sprache in eine andere Sprache übersetzt sein, hat im Zweifel
        stets die deutsche Version Vorrang.
      </div>
      <div>
        (5) Geltungserhaltung: <br /> Beide Vertragspartner sind verpflichtet,
        dann, wenn einzelne oder mehrere Regelungen aus anderen Gründen als den
        Bestimmungen betreffend das Recht der Allgemeinen Geschäftsbedingungen
        nach §§ 305 bis 310 BGB unwirksam, nichtig oder undurchführbar sind oder
        eine ausfüllungsbedürftige Regelungslücke entsteht, durch eine wirksame
        Regelung ersetzen bzw. die Lücke ausfüllen, die in ihrem rechtlichen und
        wirtschaften Gehalt der unwirksamen/nichtigen/undurchführbaren Regelung
        und dem Vertragszweck entspricht. § 139 BGB (Teilnichtigkeit) wird
        ausdrücklich ausgeschlossen. Beruht die Unwirksamkeit einer Regelung auf
        einem in ihr festgelegten Maß der Leistung oder der Zeit (Termin oder
        Frist), so ist diese Regelung mit einem dem ursprünglichen Maß am
        nächsten kommenden rechtlich zulässigen Maß zu vereinbaren. Als
        Gegenleistung entrichtet der Partner an den Veranstalter den
        vereinbarten Pauschalbetrag zuzüglich der gesetzlichen Umsatzsteuer.
        Soweit nicht anders vereinbart, sind die Beträge 28 Tage nach
        Rechnungsstellung zu entrichten. Ohne Begleichung der Rechnung ist ein
        Zutritt zur Veranstaltung und der digitalen App nicht gestattet.
      </div>
      <div>Stand dieser Teilnahmebedingungen: November 2025</div>
    </>
  );
};

export const ENGLISH_TERMS_CONTENT = () => {
  const { t } = useTranslation();
  return (
    <>
      <LegalHeading id={t('terms-and-conditions-page-scroll-to-1')}>
        A) General Terms & Conditions of Participation for Participants
      </LegalHeading>

      <LegalSubheading>§ 1 Scope of application</LegalSubheading>
      <div>
        (1) The following terms and conditions of participation apply to all
        legal transactions between we.CONECT Global Leaders GmbH, Sonnenallee
        221, 12059 Berlin, Germany (“we”) and our contractual partner (“you”)
        who participates in our events and uses our products.
      </div>
      <div>
        (2) The following terms apply within the scope of these General Terms
        and Conditions:
        <br />
        Eligibility to participate:
        <br /> is the right to participate in our event
        <br />
        Purchaser:
        <br /> is the person who obtains eligibility to participate not for
        themselves but for the participant
      </div>

      <LegalSubheading>§ 2 Conclusion of the contract</LegalSubheading>
      <div>(1) Our offers are generally non-binding and subject to change.</div>
      <div>
        (2) By submitting your declaration of participation by mail, fax, email,
        via our booking system on our website, or by verbal agreement, you are
        making a binding offer to conclude a contract.
      </div>
      <div>
        (3) A contract with we.CONECT Global Leaders GmbH is concluded when we
        accept your offer.
      </div>
      <div>
        (4) The purchaser of the participation entitlement who is not a
        participant themselves (i.e., who does not acquire or order the
        participation entitlement exclusively for themselves) is responsible for
        ensuring that the participant who receives the participation entitlement
        from them is aware of these GTC and accepts them. Only the person named
        on the participation entitlement can be a participant.
      </div>

      <LegalSubheading>§ 3 Subject matter of the contract</LegalSubheading>
      <div>
        (1) We may change individual components of an event if this is necessary
        and does not alter any essential parts of the event. In such cases,
        there shall be no entitlement to a reduction or refund of the admission
        price if the change is not significant and is reasonable under the
        circumstances of the individual case.
      </div>
      <div>
        (2) Insofar as lectures, workshops, exhibitions, evening events, etc.
        are the subject matter of the contract, we owe a proper selection of
        speakers or exhibitors, but are not responsible for their content, their
        manner of presentation, or their assertions.
      </div>
      <div>
        (3) We may replace individual speakers and presenters with other
        comparable speakers and presenters, provided this is reasonable for the
        participant and the purpose of the event and its content are not
        significantly altered.
      </div>
      <div>
        (4) We are entitled to send you information about the event via the
        means of communication you have specified.
      </div>
      <div>
        (5) We are also entitled to take photos and make video recordings on
        site. The details will be communicated to you on site via our data
        protection information; you can also request this in advance.
      </div>
      <div>(6) We reserve the right to enforce house rules.</div>

      <LegalSubheading>§ 4 Participant fees</LegalSubheading>
      <div>
        (1) If a participation fee is charged for the respective event, it will
        be specified in our price information or offers on the respective event
        website. Use of the digital event platform is only possible in
        combination with the purchase of a paid ticket or the full use
        (including attendance at the event) of a free VIP/free ticket or onsite
        ticket.
      </div>
      <div>
        (2) All invoices are issued in euros. If you pay with foreign currencies
        or means of payment, any exchange rate differences and bank charges
        shall be borne by you.
      </div>
      <div>(3) Prices are exclusive of statutory value added tax.</div>
      <div>
        (4) If you do not make use of individual services through no fault of
        our own, the agreed participation fees and any additional agreed fees
        and costs (e.g., conference flat rates) shall nevertheless be payable,
        unless otherwise agreed.
      </div>

      <LegalSubheading>
        § 5 Payment terms, eligibility, returns/exchanges
      </LegalSubheading>
      <div>
        (1) The participant must pay we.CONECT the agreed flat rate/ticket price
        plus statutory value added tax. The flat rate/ticket price plus
        statutory value added tax is due 14 days after invoicing.
      </div>
      <div>
        (2) From 14 days before the event, the flat rate/ticket price plus
        statutory value added tax is due immediately (on the same day) upon
        receipt of the invoice.
      </div>
      <div>
        (3) The tickets are personalized. Only the person whose name is printed
        on/in the ticket is entitled to participate.
      </div>
      <div>
        (4) It is generally not possible to return or exchange tickets or
        transfer participation rights to another event.
      </div>

      <LegalSubheading>
        § 6 General Terms and Conditions of Participation
      </LegalSubheading>
      <div>
        (1) General prohibitions: Disrupting the course of the event. Smoking
        in buildings outside the designated smoking areas. Committing, aiding,
        or abetting criminal, unlawful, or generally reprehensible acts.
        defacing, damaging, or removing equipment and facilities, distributing
        advertising materials without our express written consent, bringing
        animals (except guide dogs), carrying weapons, dangerous objects, or
        drugs, making audio, film, or photo recordings without our express
        written consent. <br /> In the event of a violation, we may expel you
        from the event. In this case, you will not be entitled to a refund of
        the participation fees and other costs (e.g., conference flat rates).
        Our right to claim damages remains unaffected.
      </div>
      <div>
        (2) Travel, entry requirements: You are responsible for arriving on
        time, for your return journey, and for complying with any entry
        requirements and preparing for them in good time (e.g., obtaining any
        necessary documents). (2) Anreise, Einreisebestimmungen:
        <br />
        Sie sind selbst für die rechtzeitige Anreise, für die Rückreise und für
        die Einhaltung etwaiger Einreisebestimmungen und deren rechtzeitiger
        Vorbereitung (z.B. Beschaffung ggf. notwendiger Unterlagen)
        verantwortlich.
      </div>
      <div>
        (3) Hygiene rules:
        <br /> If officially required, the official hygiene rules and official
        requirements in force at the venue at the time of the event shall apply.
        <br /> It is a condition of admission that participants are able to
        fully comply with and fulfill these hygiene rules and requirements
        during their stay at the event venue. <br />
        The hygiene rules and requirements can be found on our website or we
        will be happy to send them to you on request.
      </div>

      <LegalSubheading>§ 7 Copyrights</LegalSubheading>
      <div>
        (1) The files provided to you (presentations, handouts, etc.) are
        subject to copyright law even if they do not meet the required level of
        creativity in individual cases. You may only use the documents and data
        for private use and within the scope of the permissions granted by
        copyright law.
      </div>
      <div>
        (2) You are permitted to take photos, make video recordings, and audio
        recordings during the event to a reasonable extent.
      </div>

      <LegalSubheading>§ 8 Force majeure</LegalSubheading>
      <div>
        (1) In the event that force majeure leads to the termination or
        interruption of the contract or the event or individual contractual
        services, we may demand from you a proportionate share of the costs
        incurred and services rendered up to that point, provided that you are
        an entrepreneur within the meaning of § 14 BGB (German Civil Code), but
        not exceeding 5% of the participation fees. This also applies if one of
        our service providers (e.g., the event venue) is unable to provide its
        services to us due to force majeure. There shall be no claims for
        damages against us.
      </div>
      <div>
        (2) Official, police, or court orders to suspend or terminate the event
        shall be deemed force majeure as defined in paragraph 1, unless we are
        culpably responsible for such orders.
      </div>
      <div>
        (3) It is agreed that force majeure within the meaning of paragraph 1
        also includes recommendations by government authorities (federal, state,
        ministries, agencies) not to hold the event (e.g., due to a
        pandemic-like spread of a virus or a terror warning).
      </div>
      <div>
        (4) It is refutably presumed that we can invoke force majeure within the
        meaning of paragraph 1 if comparable events in the same or neighboring
        states, in which the event also takes place, are canceled or do not take
        place at the same time. It is also refutably assumed that we cannot
        invoke force majeure if comparable events in the same or neighboring
        federal states in which the event is also taking place are taking place
        at the same time.
      </div>
      <div>
        (5) If a significant number of participants cancel their participation
        or attendance at the event, citing an extraordinary event, and the event
        thereby loses its defining character, the organizer is entitled to
        cancel the event with the legal consequences set out in paragraph 1. If
        the cancellation is based exclusively on a significant number of
        cancellations by other service providers, we may invoke force majeure in
        accordance with paragraph 1, but in this case we shall have no pro rata
        claim against the participant.
      </div>
      <div>
        (6) It is agreed that force majeure also applies if the implementation
        of the event is economically unreasonable for us due to other
        requirements imposed by the authorities, insofar as we are not
        responsible for these. In this case, we may invoke force majeure in
        accordance with paragraph 1, but we shall not have any proportionate
        claim against the participant.
      </div>
      <div>
        (7) If a participant is denied entry or further participation in the
        event, and this denial is based on an official requirement that persons
        with symptoms of illness are not allowed to participate, this
        circumstance shall be considered force majeure within the meaning of
        paragraph 1. If you claim to have symptoms of illness on site or without
        appearing, we may require you to present a medical certificate stating
        that participation would not be possible due to official requirements.
      </div>
      <div>
        (8) As a less severe measure than canceling the entire event as a live
        event due to force majeure, we are entitled, but not obligated, to hold
        the event digitally in whole or in part. If this means that essential
        content is not delivered as contractually owed, the participation fees
        shall be adjusted accordingly. Furthermore, a participant shall not be
        entitled to claim damages from us due to a force majeure-related
        transfer to the digital domain.
      </div>
      <div>
        (9) If the event is announced from the outset as a so-called hybrid
        event (i.e., the event is held digitally, but participants can also
        attend in person) and the event must be held exclusively digitally due
        to force majeure, the participant shall have no claims for reimbursement
        or damages against us.
      </div>
      <div>
        (10) We may also cancel the event for reasons of respect or offer you an
        alternative date. Reasons of respect apply if flags are flown at
        half-mast or are to be flown at half-mast in the region of the event
        location, or if a serious accident or disaster has occurred within 24
        hours prior to the start of the event that is reported in the majority
        of media outlets in the region of the event location, or if the incident
        occurred more than 24 hours ago but is still being reported in the
        majority of media outlets in the region of the event location.
        misfortune occurs within 24 hours before the start of the event, which
        is reported in the majority of the media in the region of the event
        location, or if the incident occurred more than 24 hours ago, but the
        reporting in the majority of the media is still present through special
        broadcasts, or if comparable events are canceled due to the same
        incident. In this case, we will refund any participation fees already
        paid, excluding any advance booking fees incurred. Claims for damages
        are excluded.
      </div>

      <LegalSubheading>§ 9 Cancellation by you</LegalSubheading>
      <div>
        (1) If you wish to cancel the contract for a reason for which we are not
        responsible and which is not due to force majeure (“cancellation”), this
        is generally possible in consultation with us; we may not refuse the
        cancellation in bad faith. In the event of a mutual cancellation of the
        contract, we may, in view of the fact that experience has shown that we
        are unable to reallocate the vacant places in the event of a
        cancellation and that we may not be able to cancel our agents or
        speakers free of charge, claim costs and fees, etc. in accordance with
        the following provisions, unless otherwise agreed with you:
      </div>
      <div>
        (2) We will either claim the specifically agreed costs minus any
        expenses saved or charge a flat rate for our costs and lost profits. In
        this case, the following flat rates apply: Up to 5 working days from the
        booking date: 80% of the participation fee; thereafter or in case of
        non-attendance: 100% of the participation fee.
      </div>

      <LegalSubheading>§ 10 Data protection</LegalSubheading>
      <div>
        Please refer to our privacy policy, which you can view in connection
        with your registration and also request from us at any time.
      </div>

      <LegalSubheading>§ 11 Our liability</LegalSubheading>
      <div>
        (1) Breaches of duty resulting in property damage or financial loss: In
        the case of breaches of duty due to slight negligence, our liability
        shall be limited to the average damage typical for this type of contract
        and foreseeable under the terms of the contract. <br /> We shall not be
        liable for only slightly negligent breaches of insignificant contractual
        obligations. “Insignificant” refers to obligations whose fulfillment
        does not characterize the contract and on which you cannot rely. <br />
        Indirect damage and consequential damage resulting from defects in the
        subject matter of the contract shall only be eligible for compensation
        if such damage is typically to be expected when the subject matter of
        the contract is used as intended. <br /> The limitations of liability in
        this paragraph 1 do not apply in the event of grossly negligent or
        intentional breaches of duty.
      </div>
      <div>
        (2) Breaches of duty resulting in injury to life, limb, or health: We
        are liable for any kind of negligence and intent in the event of injury
        to your life, limb, or health attributable to us.
      </div>
      <div>
        (3) Mandatory legal liability: The limitations of liability in paragraph
        1 do not affect your claims arising from product liability and mandatory
        legal liability.
      </div>
      <div>
        (4) Extension of this clause to employees, organs, vicarious agents,
        etc.: The limitations of liability in paragraph 1 apply to the same
        extent in favor of our organs, our employees and other vicarious agents,
        and our subcontractors.
      </div>

      <LegalSubheading>
        § 12 Place of jurisdiction and choice of law
      </LegalSubheading>
      <div>
        (1) Place of jurisdiction: Our place of business shall be agreed as the
        place of jurisdiction if you are a merchant or do not have a general
        place of jurisdiction in the Federal Republic of Germany. In this case,
        however, we shall also be entitled to bring legal action at your place
        of business.
      </div>
      <div>
        (2) Choice of law: If you are an entrepreneur (§ 14 BGB), German law
        shall apply. If you are a consumer (§ 13 BGB), the following applies:
        These General Terms and Conditions and the contractual relationship with
        you are governed by the law of the Federal Republic of Germany,
        excluding substantive EU law. However, the statutory provisions
        restricting the choice of law remain unaffected. In particular, pursuant
        to Article 6(2) of Regulation (EC) No. 593/2008 (the so-called “Rome I
        Regulation”) within its territorial scope of application: Insofar as the
        law of the country in which you have your habitual residence at the time
        of conclusion of the contract (hereinafter referred to as “law of
        residence”) contains provisions for your protection which, according to
        the law of residence, cannot be deviated from by agreement, the (more
        favorable) provisions of your law of residence shall apply to you. This
        means that, despite the choice of law in accordance with sentence 1, you
        will always enjoy the protection of the mandatory provisions of the law
        of your country of residence.
      </div>

      <LegalHeading id={t('terms-and-conditions-page-scroll-to-2')}>
        B) General Terms and Conditions & Conditions of Participation for
        Sponsors/Business Partners
      </LegalHeading>

      <LegalSubheading>§ 1 Scope of application</LegalSubheading>
      <div>
        (1) The following terms and conditions of participation apply to all
        legal transactions between we.CONECT Global Leaders GmbH, Sonnenallee
        221, 12059 Berlin, Germany (“we”) and our contractual partner (“you”)
        who participates in our events and uses our products.
      </div>
      <div>
        (2) The following terms apply within the scope of these General Terms
        and Conditions:
        <br />
        Eligibility to participate is the right to participate in our event and
        to act as an exhibitor, sponsor, or business partner.
        <br />
        Purchaser is the person who obtains eligibility to participate not for
        themselves, but for the exhibitor, sponsor, or business partner.
      </div>

      <LegalSubheading>§ 2 Conclusion of the contract</LegalSubheading>
      <div>(1) Our offers are generally non-binding and subject to change.</div>
      <div>
        (2) By submitting your declaration of participation by mail, fax, email,
        via our booking system on our website, or by verbal agreement, you are
        making a binding offer to conclude a contract.
      </div>
      <div>
        (3) A contract with we.CONECT Global Leaders GmbH is concluded when we
        accept your offer.
      </div>
      <div>
        (4) The purchaser of the participation entitlement who is not themselves
        an exhibitor, sponsor, or business partner (i.e., who does not acquire
        or order the participation entitlement exclusively for themselves) is
        responsible for ensuring that the exhibitor, sponsor, or business
        partner who receives the participation entitlement from them is aware of
        these General Terms and Conditions and accepts them.
      </div>

      <LegalSubheading>
        § 3 Exhibitor, sponsor, business partner, and participant fees
      </LegalSubheading>
      <div>
        (1) The exhibitor, sponsor, business partner, and participant fees are
        based on our price lists or offers on the respective event website
        and/or on the offer from our sales department.
      </div>
      <div>
        (2) All invoices are issued in euros. If you pay with foreign currencies
        or means of payment, you are responsible for any exchange rate
        differences and bank charges.
      </div>
      <div>(3) Prices are exclusive of statutory value added tax.</div>

      <LegalSubheading>
        § 4 Payment terms, eligibility to participate
      </LegalSubheading>
      <div>
        (1) The exhibitor, sponsor, business partner, or participant must pay
        we.CONECT the agreed flat rate, ticket, or package price plus statutory
        value-added tax. The flat rate, ticket, or package price plus statutory
        value-added tax is due 14 days after invoicing.
      </div>
      <div>
        (2) From 14 days prior to the event, the flat rate, ticket, or package
        price plus statutory value-added tax is due immediately (on the same
        day) upon receipt of the invoice.
      </div>

      <LegalSubheading>
        § 5 Services and obligations of the organizer
      </LegalSubheading>
      <div>
        (1) The organizer grants the partner the individually agreed advertising
        measures. This includes all corporate communication measures and
        services that are permitted and provided to the partner in connection
        with the event.
      </div>
      <div>
        (2) The organizer may also conclude sponsorship agreements with other
        partners/sponsors from the same industry or make use of or commission
        their services for the event.
      </div>
      <div>
        (3) The organizer shall provide the partner with brief information about
        the services rendered shortly after the event.
      </div>
      <div>
        (4) The organizer may make changes to the content, location, time, and
        schedule of the event, provided that these are insignificant and
        reasonable for the partner in order to achieve the purpose of the
        contract.
      </div>

      <LegalSubheading>
        § 6 Services and obligations of the partner
      </LegalSubheading>
      <div>
        (1) The Partner shall comply with the provisions set out in this
        Agreement.
      </div>
      <div>
        (2) If the Partner has the right to set up or operate a booth, the
        Organizer’s General Terms and Conditions for Exhibitors shall apply
        accordingly.
      </div>
      <div>
        (3) The Partner shall submit appropriate branding material for the event
        no later than 14 days before the event date.
      </div>
      <div>
        (4) If agreed One2Ones are included in the package, ticket, or contract,
        these shall be posted independently via the event app provided.
      </div>

      <LegalSubheading>
        § 7 Use of trademarks, logos, copyrights, etc.
      </LegalSubheading>
      <div>
        (1) Both contracting parties guarantee that the other contracting party
        may use names, works, titles, logos, and trademarks (hereinafter
        referred to as “logos”) publicly for the purpose of executing the
        contract and shall receive a simple right of use for this purpose. Both
        contracting parties shall provide each other with the rights to the
        trademarks necessary for this purpose free of charge for the purpose of
        carrying out the event and implementing the services and
        responsibilities and shall guarantee that these rights are free from
        third-party rights. Through the contractual use of a trademark, the
        using contracting party shall not acquire any rights to it beyond those
        specified in this contract. <br />
        Both contracting parties also undertake not to register or have the
        existing trademarks registered in other countries or to use or have them
        used in any other way in order to generate rights there.
      </div>
      <div>
        (2) Insofar as the contracting parties acquire joint rights to a
        trademark in the future, the above paragraph 1 shall apply mutatis
        mutandis, with the proviso that both contracting parties shall become
        equal rights holders. <br />
        Both contracting parties also undertake, after conclusion of the
        contract, not to register or have registered the existing trademarks in
        Germany or in other countries, or to use them or have them used in order
        to generate rights there. Registration may be carried out jointly or by
        means of a separate agreement.
      </div>
      <div>
        (3) If a contracting party or rights holder imposes certain requirements
        on its trademark from a legal perspective or from the perspective of
        corporate identity, the other contracting party must be notified of this
        in advance.
      </div>
      <div>
        (4) Pledging or licensing rights under this contract is excluded.
      </div>
      <div>
        (5) Documents, graphics, lists, drawings, sketches, and other items
        created by the contractual partner shall remain its property, unless the
        transfer of ownership is the subject matter of the contract.
      </div>
      <div>
        (6) Indemnification obligation: The partner is obliged to indemnify the
        organizer against any claims by third parties and costs incurred as a
        result of claims by third parties, insofar as the claims are based on a
        breach by the partner of one of the provisions agreed here, agreements
        from an individual order, from a subsequent agreement, or if a legal or
        other regulation or otherwise unlawful conduct. This indemnification
        obligation shall continue to apply within the scope of the statutory
        limitation period even after the end of the contract if the claim is
        made after the end of the contract. This shall also apply if the
        contract is terminated prematurely due to force majeure or other events.
      </div>
      <div>
        (7) This applies to advertising measures of any kind agreed in
        accordance with § 1, as well as to the partner’s presence at the live
        event (whether physical or digital) and to any digital implementation of
        the event.
      </div>

      <LegalSubheading>
        § 8 If agreed: Location, presentation, visibility
      </LegalSubheading>
      <div>
        (1) The organizer may allocate space to exhibitors at its own
        discretion; exhibitors shall only be entitled to a specific amount of
        space if this has been expressly agreed in writing.
      </div>
      <div>
        (2) The provision of a stand space is subject to the condition that the
        exhibition stand, its contents, the goods presented there, the type of
        presentation, and the personnel do not cause any nuisance to third
        parties, in particular do not disturb other exhibitors, and do not
        conflict with the purpose of the event.
      </div>
      <div>
        (3) The organizer may relocate the allocated stand space, unless
        otherwise agreed, provided that the relocation is reasonable for the
        partner and does not impair the purpose of the contract.
      </div>
      <div>
        (4) The Partner may only transfer the space allocated to it to third
        parties with the prior, express, written consent of the organizer. The
        Partner is responsible for ensuring that these terms and conditions are
        accepted and complied with by third parties. Consent by the organizer
        shall only release the Partner from the rights and obligations set out
        herein if both parties have expressly agreed to this in writing.
      </div>
      <div>
        (5) The areas provided must be kept clean and tidy during the event. The
        stand must be staffed by knowledgeable personnel during the event. The
        Partner is solely responsible for the safety of the stand operation.
      </div>
      <div>
        (6) Advertising outside the stand is only permitted with the prior
        express written consent of the Organizer.
      </div>
      <div>
        (7) The organizer is not responsible for guarding the stand. The partner
        is advised to ensure adequate security and insurance.
      </div>
      <div>
        (8) The organizer is entitled to urgently operate the event venue, which
        the organizer makes available to the partner upon request.
      </div>
      <div>
        (9) Hygiene rules:
        <br /> If officially required, the official hygiene rules and official
        requirements in force at the venue at the time of the event shall apply.
        <br />
        It is a condition of admission that the participant is able to fully
        comply with and fulfill these hygiene rules and requirements during
        their stay at the event venue. The hygiene rules and requirements can be
        found on our website or we will be happy to send them to you on request.
      </div>
      <div>
        (10) Hybrid or digital events:
        <br /> If the event takes place entirely or partially digitally and the
        partner is given the opportunity to present themselves digitally, the
        partner guarantees that the organizer will be granted the necessary
        rights for any event-related use by the organizer. This also applies
        insofar as the personal rights or personal data of employees or
        assistants of the partner are affected.
      </div>

      <LegalSubheading>§ 9 Content of activities</LegalSubheading>
      <div>
        (1) Both contracting parties guarantee that their own actions/statements
        do not contain any political, discriminatory, racist, extremist, or
        otherwise immoral statements, insinuations, or representations; do not
        contain any statements, insinuations, or representations that are
        incompatible with fundamental democratic values and/or the Basic Law of
        the Federal Republic of Germany and/or have a negative impact on
        peaceful coexistence among people in Germany; do not contain any
        statements, insinuations, or representations that damage the positive
        image of the other contracting party.
      </div>
      <div>
        (2) The contracting parties shall inform each other immediately if they
        disagree with the other party’s actions, measures, marketing activities,
        etc., or if they discover any violations.
      </div>
      <div>
        (3) The contracting parties shall disclose their plans and activities
        relating to the performance of the contract at any time upon request and
        shall support each other in maintaining a positive image.
      </div>

      <LegalSubheading>§ 10 Exchange of information</LegalSubheading>
      <div>
        In the event of an accident or a safety-related incident that attracts
        media attention, the contracting parties shall coordinate their
        statements to the press and exchange information.
      </div>

      <LegalSubheading>§ 11 Confidentiality</LegalSubheading>
      <div>
        (1) The contracting parties agree to maintain absolute confidentiality
        regarding trade and business secrets, even after the end of the
        contract.
      </div>
      <div>
        (2) Trade and business secrets are understood to be all facts,
        circumstances, and processes relating to the company that are not public
        knowledge but are only accessible to a limited group of people and in
        whose non-disclosure the legal owner has a legitimate interest. Trade
        secrets essentially include technical knowledge, processes, plans,
        experience, recipes, design drawings, and commercial knowledge.
      </div>
      <div>
        (3) The contracting parties undertake to maintain confidentiality
        towards third parties regarding the amount of the agreed payments and
        the content of this contract. This shall continue to apply after the end
        of the contract.
      </div>

      <LegalSubheading>§ 12 Data protection</LegalSubheading>
      <div>
        (1) Employees or subcontractors of the partner: Use of data / disclosure
        under data protection information: The partner is obliged to inform its
        employees and subcontractors as contractual partners of the data
        protection information obligations, which are also passed on to the
        responsible persons and contact persons to be named by the partner, and
        to inform them comprehensively, in a timely manner, and in a verifiable
        manner about the data processing operations and data protection measures
        carried out in connection with the contract.
      </div>
      <div>
        (2) Joint responsibility, further agreements: Where necessary, the
        contracting parties shall also conclude appropriate data protection
        agreements based on the EU General Data Protection Regulation (GDPR
        e.g., a contract on joint responsibility in accordance with Art. 26 GDPR
        or a data processing agreement in accordance with Art. 28 GDPR).
      </div>

      <LegalSubheading>§ 13 Liability</LegalSubheading>
      <div>
        (1) The organizer does not guarantee that the partner will achieve
        advertising success. In particular, the organizer does not guarantee
        that a sufficient number of visitors will actually attend the event.
      </div>
      <div>
        (2) Both contracting parties exclude their liability for property damage
        and financial loss caused by slight negligence on the part of the other
        contracting party. Claims by third parties are not excluded.
      </div>

      <LegalSubheading>
        § 14 Force majeure and (partial) non-performance of the event
      </LegalSubheading>
      <div>
        (1) In the event of force majeure leading to the cancellation,
        termination, or interruption of the supported event, any services
        already exchanged shall be reversed and both contracting parties shall
        lose any existing or future claims for services (claims for payment,
        claims for advertising, or claims for the execution of the event)
        against the other party. No claims for damages shall arise. This shall
        not apply if the service already rendered by one contracting party
        without a balanced service from the other contracting party would lead
        to an unexpected disadvantage for the (already) performing contracting
        party or to an advantage for the other contracting party that is
        contrary to good faith (e.g. if the organizer has already carried out
        advertising measures in favor of the partner, but the partner has not
        yet made any payments; or if the partner has already made payments, but
        the organizer has not yet initiated any advertising measures). In this
        respect, it is therefore agreed that the services specified in § 1 are
        divisible. <br />
        The following applies to all live and hybrid event formats: It is
        presumed, subject to rebuttal by either party, that the four service
        packages each account for the following percentages of the total value:
        “Pre-event” = 10%, “During live event” = 40%, “During digital event” =
        30%, and “Post-event” = 20%. These package values, unless the
        presumption is rebutted, shall form the basis for the valuation of the
        divisible services. The following applies to all purely digital event
        formats: It is rebuttably presumed for both parties that the three
        service packages each account for the following percentages of the total
        value: “Before the event” = 20%, “At the digital event” = 50% and “After
        the event” = 30%. Unless the presumption is refuted, these package
        values shall be used as the basis for the valuation of the divisible
        services actually rendered.
      </div>
      <div>
        (2) Official, police, or court orders to suspend or terminate the event
        shall be deemed force majeure as defined in paragraph 1, unless a
        contracting party is culpably responsible for such an order.
      </div>
      <div>
        (3) Government recommendations not to hold the event (e.g.,
        pandemic/terror warning) are also deemed force majeure.
      </div>
      <div>
        (4) Force majeure also applies if the organizer is unable to hold the
        event on economic grounds due to increased requirements imposed by the
        authorities, insofar as the organizer is not responsible for these
        requirements. In this case, the organizer may invoke force majeure in
        accordance with paragraph 1.
      </div>
      <div>
        (5) Rebuttable presumptions regarding comparable events in the
        same/adjacent federal state apply (as set out above).
      </div>
      <div>
        (6) Health protection clause per RKI/authority guidelines (symptoms
        leading to exclusion) with irreplaceability applies.
      </div>
      <div>
        (7) Significant cancellations that destroy the defining character of the
        event entitle the organizer to cancel per paragraph 1.
      </div>
      <div>
        (8) “Respect” can be a reason to cancel; see indicators described.
      </div>
      <div>
        (9) Transformation from live to digital permitted as a milder remedy;
        mutual services to be adjusted appropriately; lower/upper bounds 20%/80%
        apply; partner may withdraw if unreasonable, with immediate declaration
        after announcement; corresponding exhibitor conditions apply.
      </div>

      <LegalSubheading>§ 14 Termination of the contract</LegalSubheading>
      <div>
        (1) This contract only concerns the event that is the subject of the
        contract and ends when the event has been completed in full between the
        contracting parties. The right to terminate this contract by giving
        notice is excluded, unless agreed in paragraph 2.
      </div>
      <div>
        (2) The organizer may terminate the contract without giving reasons if
        the event in question is cancelled or is not or cannot/may not be
        carried out by the organizer. The organizer’s fault is irrelevant.
      </div>
      <div>
        (3) Either party may terminate for purpose-/breach-related reasons
        harming image or misuse.
      </div>
      <div>
        (4) If neither contracting party is at fault for the termination, the
        provisions governing force majeure shall apply accordingly. If one
        contracting party is at fault for the termination, it shall lose its
        claim for performance against the other party but shall remain obliged
        to perform the agreed service and shall be liable to the terminating
        contracting party for damages in lieu of performance, at the latter’s
        discretion. Terminations pursuant to paragraph 2 shall not be deemed to
        have been culpably caused if the reasons for termination are
        event-related (lack of exhibitors, lack of reporting, scheduling
        conflicts, financial difficulties in implementation) and do not
        contradict good faith (e.g. in order to enter into an exclusive
        partnership with another partner at the same time).
      </div>
      <div>
        (5) Termination for good cause examples: persistent legal breaches,
        cessation of business, insolvency, change of control &gt; 50% affecting
        interests significantly.
      </div>
      <div>
        (6) Post-termination rights: limited continued use/PR as described;
        avoidance of implying sole rights holder; prohibition for cause
        possible; standards of “contemporary historical event” apply over time.
      </div>

      <LegalSubheading>§ 15 Non-solicitation clause</LegalSubheading>
      <div>
        The contractual partner shall refrain from making employment offers to
        employees of we.CONECT Global Leaders GmbH during the term of the
        cooperation between the parties and for two calendar years thereafter
        (non-solicitation clause). Such an employment contract is equivalent to
        other offers and agreements based on which the employee&apos;s labour no
        longer benefits we.CONECT Global Leaders GmbH, but wholly or partly the
        contracting party. For each violation of this non-solicitation clause in
        accordance with this article, the contractual partner undertakes to pay
        we.CONECT Global Leaders GmbH a contractual penalty of 100% (one hundred
        per cent) of the annual gross amount paid by the contractual partner to
        this person, but not less than EUR 65,000.00 (sixty-five thousand
        euros). This shall not affect we.CONECT Global Leaders&apos; right to
        assert claims for damages in excess of the contractual penalty. The
        contractual partner shall bear the burden of proof.
      </div>

      <LegalSubheading>§ 16 Miscellaneous</LegalSubheading>
      <div>
        (1) Assignment:
        <br />
        The Partner may only assign claims arising from the contractual
        relationship to third parties with the prior express consent of the
        Organizer.
      </div>
      <div>
        (2) Place of jurisdiction:
        <br />
        The place of jurisdiction for all claims arising from the contractual
        relationship is the Organizer’s registered office. The Organizer is also
        entitled to choose the place of jurisdiction at the Partner&apos;s
        registered office.
      </div>
      <div>
        (3) Choice of law: <br /> German law shall apply.
      </div>
      <div>
        (4) Language:
        <br />
        If these General Terms and Conditions are translated into a language
        other than German, the German version shall always take precedence in
        case of doubt.
      </div>
      <div>
        (5) Validity:
        <br />
        Both contracting parties are obliged, if individual or multiple
        provisions are invalid, void or unenforceable for reasons other than the
        provisions concerning the law on general terms and conditions pursuant
        to Sections 305 to 310 of the German Civil Code (BGB), void or
        unenforceable for reasons other than the provisions concerning the law
        on general terms and conditions pursuant to Sections 305 to 310 of the
        German Civil Code (BGB), or if a loophole requiring filling arises, to
        replace the invalid/void/unenforceable provision with a valid provision
        or to fill the loophole with a provision that corresponds to the legal
        and economic content of the invalid/void/unenforceable provision and the
        purpose of the contract. Section 139 of the German Civil Code (BGB)
        (partial invalidity) is expressly excluded. If the invalidity of a
        provision is based on a measure of performance or time (date or
        deadline) specified therein, this provision shall be agreed with a
        legally permissible measure that comes closest to the original measure.
        In return, the Partner shall pay the Organizer the agreed flat rate plus
        statutory value added tax. Unless otherwise agreed, the amounts are
        payable 28 days after invoicing. Access to the event and the digital app
        is not permitted without payment of the invoice.
      </div>
      <div>Status of these conditions of participation: November 2025</div>
    </>
  );
};
